export enum CalendarStyles {
    calendar = "calendar",
    list = "list",
}